import { queryClient } from '../../lib';
import { type GetWorkspaceRequest, getSingleWorkspace } from '../../lib/api/workspaces';
import { API_TAGS } from '../../lib/constants';
import { useGetUsersSingleWorkspaceQuery } from '../api/useWorkspaces';
import { usePermissions } from '../usePermissions';

export const prefetchData = (params: GetWorkspaceRequest) =>
  queryClient.prefetchQuery({
    queryKey: [API_TAGS.SingleWorkspace, params],
    queryFn: () => getSingleWorkspace(params),
  });

export const useSingleWorkspace = (params: GetWorkspaceRequest) => {
  const { email: permissionEmail } = usePermissions();

  const isEnabled = !!(params.accountID && params.workspaceID && permissionEmail);

  const { data, isLoading, error, isError, isFetching, refetch } = useGetUsersSingleWorkspaceQuery(params, {
    enabled: isEnabled,
  });

  const isWorkspaceLoading = isLoading || !isEnabled;

  return {
    workspace: data,
    isWorkspaceLoading,
    isWorkspaceRefetching: isFetching,
    isWorkspaceError: isError,
    workspaceError: error,
    workspaceRefetch: refetch,
  };
};
